import { useEffect, useState } from "react";
import full from "../../../../assets/branchRanking/10134048.png";
import half from "../../../../assets/branchRanking/10134048-halfy.png";
import empty from "../../../../assets/branchRanking/empty.png";
import cry from "../../../../assets/branchRanking/cryabc.png";

interface IProps {
    rev: number,
    exp: number,
}

export const Rating = (props: IProps) => {
    const [rating, setRating] = useState<number>(0);

    const getProfitRating = (revenue: number, exp: number) => {
        if (revenue <= 0) return 0;

        const ratio = exp / revenue;

        // Maximum 5 stars (10x or above)
        if (ratio >= 10) return 5;

        // Every 2x = 1 star
        const fullStars = Math.floor(ratio / 2);

        // Remaining ratio
        const remainder = ratio % 2;

        let stars = fullStars;

        // Half star if between star levels
        if (remainder > 0) {
            stars += 0.5;
        }

        setRating(prev => prev = Math.min(stars, 5));
    };

    useEffect(() => {
        if ((props.rev < props.exp)) getProfitRating(props.rev, props.exp);
    }, []);

    return (
        (props.rev < props.exp) ? (
            <div className="flex">
                <img src={cry} width={20} alt="cry" />
                <img src={cry} width={20} alt="cry" />
                <img src={cry} width={20} alt="cry" />
            </div>
        ) : (<div className="flex">
            {[1, 2, 3, 4, 5].map((star) => {
                if (rating >= star) {
                    return (
                        <img src={full} width={20} alt="star" />
                    );
                }

                if (rating >= star - 0.5) {
                    return (
                        <div style={{ width: "14px", height: "21px", marginRight: "7px" }}>
                            <img src={half} style={{ width: "100%", height: "100%" }} alt="half-star" />
                        </div>
                    );
                }

                return (
                    <img src={empty} width={20} alt="empty-star" />
                );
            })}
        </div>)
    );
}